import { render, staticRenderFns } from "./FilterJournalists.vue?vue&type=template&id=612a7bb3&"
import script from "./FilterJournalists.vue?vue&type=script&lang=js&"
export * from "./FilterJournalists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports